<template>
  <div>
    <b-form-group v-if="isEnabled24TV != null" label-align="left" :label="$t(isEnabled24TV.description)" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-checkbox size="lg" switch class="mt-2" v-model="isEnabled24TV.raw_values[0].value" unchecked-value="0" value="1"/>
    </b-form-group>
    <b-form-group label-align="left" v-if="token" :label="$t(token.description)" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="text" v-model="token.raw_values[0].value"/>
    </b-form-group>
    <b-form-group label-align="left" v-if="login" :label="$t(login.description)" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="text" v-model="login.raw_values[0].value"/>
    </b-form-group>
    <b-form-group label-align="left" v-if="password" :label="$t(password.description)" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="text" v-model="password.raw_values[0].value"/>
    </b-form-group>
    <md-button class="md-raised" @click="SaveAll" >{{ $t('Save') }}</md-button>
  </div>
</template>

<script>
export default {
  methods: {
    SaveAll () {
      this.SaveSystemSetting(this.isEnabled24TV)
      this.SaveSystemSetting(this.token)
      this.SaveSystemSetting(this.login)
      this.SaveSystemSetting(this.password)
      this.$root.$emit('makeToasts')
      setTimeout(this.$store.dispatch, 1000, 'Settings/GET_REGISTRY_SETTINGS', {group_id: 17, object_id: 0})
    },
    changeIsEnabled (value) {
      this.ChangeSystemSetting(value, this.isEnabled24TV)
    },
    changeAPIKey (value) {
      this.ChangeSystemSetting(value, this.token)
    },
    changeLogin (value) {
      this.ChangeSystemSetting(value, this.login)
    },
    changePassword (value) {
      this.ChangeSystemSetting(value, this.password)
    },
    SaveSystemSetting (setting) {
      let tmp = JSON.parse(JSON.stringify(setting))
      tmp.object_id = 0
      tmp.raw_values[0].value = String(setting.raw_values[0].value)
      this.$store.dispatch('Settings/UPDATE_REGISTRY_SETTING', tmp).then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        }
      })
    },
    ChangeSystemSetting (value, setting) {
      let tmp = JSON.parse(JSON.stringify(setting))
      tmp.object_id = 0
      tmp.raw_values[0].value = String(value)
      this.$store.dispatch('Settings/UPDATE_REGISTRY_SETTING', tmp).then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.$root.$emit('makeToasts')
        }
      })
      setTimeout(this.$store.dispatch, 500, 'Settings/GET_REGISTRY_SETTINGS', {group_id: 17, object_id: 0})
    }
  },
  computed: {
    tv24Users () {
      return this.$store.getters['Settings/TV_24_USERS']
    },
    registrySettings () {
      return JSON.parse(JSON.stringify(this.$store.getters['Settings/REGISTRY_SETTINGS']))
    },
    isEnabled24TV () {
      let tmp = this.registrySettings.filter(el => {
        return el.name === '24tv_is_enabled'
      })
      return tmp.length ? tmp[0] : null
    },
    token () {
      let tmp = this.registrySettings.filter(el => {
        return el.name === '24tv_api_key'
      })
      return tmp.length ? tmp[0] : null
    },
    login () {
      let tmp = this.registrySettings.filter(el => {
        return el.name === '24tv_login'
      })
      return tmp.length ? tmp[0] : null
    },
    password () {
      let tmp = this.registrySettings.filter(el => {
        return el.name === '24tv_password'
      })
      return tmp.length ? tmp[0] : null
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_REGISTRY_SETTINGS', {group_id: 17, object_id: 0})
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/customerPortal/24tv/settings.vue